import React, { PropTypes } from 'react';

import { NitroParagraph, NitroModal } from 'nitro-components';

const SummaryConfirm = ({ onConfirm, onCancel, isOpen }) => (
  <NitroModal
    isOpen={isOpen}
    close={onCancel}
    title="Change vehicle"
    action={onConfirm}
    actionLabel="Change vehicle"
    cancelAction={onCancel}
    cancelLabel="Cancel">

    <NitroParagraph align="center" noMargin>Are you sure you want to change vehicle?</NitroParagraph>
    <NitroParagraph align="center">All progress in this current quote will be lost.</NitroParagraph>

  </NitroModal>
);

SummaryConfirm.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired
};

export default SummaryConfirm;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/create/components/SummaryConfirm.js